import { useState } from "react";

// Clicar numa entrada da legenda esconde/mostra a série correspondente. O payload da legenda do recharts
// expõe `dataKey` (= a key da série). Devolve o conjunto de séries escondidas (para o `hide` de cada
// Line/Bar) e as props a espalhar no <Legend> (onClick + estilo riscado/cinzento nas escondidas).
export const useLegendToggle = () => {
    const [hiddenKeys, setHiddenKeys] = useState<Set<string>>(new Set());

    const toggleSeries = (seriesKey: string) => {
        setHiddenKeys((previousHiddenKeys) => {
            const nextHiddenKeys = new Set(previousHiddenKeys);
            if (nextHiddenKeys.has(seriesKey)) nextHiddenKeys.delete(seriesKey);
            else nextHiddenKeys.add(seriesKey);
            return nextHiddenKeys;
        });
    };

    const legendProps = {
        onClick: (legendItem: any) => toggleSeries(String(legendItem?.dataKey ?? "")),
        formatter: (value: string, legendItem: any) => {
            const seriesKey = String(legendItem?.dataKey ?? "");
            const isHidden = hiddenKeys.has(seriesKey);
            const styledLabel = (
                <span style={{ cursor: "pointer", color: isHidden ? "#bbb" : "#333", textDecoration: isHidden ? "line-through" : "none" }}>
                    {value}
                </span>
            );
            return styledLabel;
        },
    };

    const legendToggle = { hiddenKeys, legendProps };
    return legendToggle;
};
